import { lazy, Suspense } from 'react'

import './App.css'
import { PreferencesProvider } from './PreferencesContext'
import Landing from './pages/Landing'

const NotFound = lazy(() => import('./pages/NotFound'))
const ProjectDetail = lazy(() => import('./pages/ProjectDetail'))

const pageFallback = (
  <div
    className="min-h-dvh bg-[var(--page)]"
    role="status"
    aria-label="Loading page"
  />
)

function AppContent() {
  const pathname = window.location.pathname
  const projectMatch = pathname.match(/^\/projects\/([^/]+)\/?$/)
  if (projectMatch) {
    let projectIdentifier = projectMatch[1]
    try {
      projectIdentifier = decodeURIComponent(projectIdentifier)
    } catch {
      // Keep the original segment so the API can return a regular not-found response.
    }
    return (
      <Suspense fallback={pageFallback}>
        <ProjectDetail projectIdentifier={projectIdentifier} />
      </Suspense>
    )
  }

  if (pathname !== '/') {
    return <Suspense fallback={pageFallback}><NotFound /></Suspense>
  }

  return <Landing />
}

function App() {
  return (
    <PreferencesProvider>
      <AppContent />
    </PreferencesProvider>
  )
}

export default App
